import React from "react";

const Select = ({
  value,
  onChange,
  options = [],
  className = "",
  ...props
}) => {
  return (
    <div className="relative inline-block">
      <select
        value={value}
        onChange={onChange}
        className={[
          "appearance-none bg-white border border-border rounded-lg pl-3 pr-8 py-1.5",
          "text-xs font-semibold text-ink-700 cursor-pointer shadow-card",
          "focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary",
          className,
        ].join(" ")}
        {...props}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-ink-500">
        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
        </svg>
      </div>
    </div>
  );
};

export default Select;
